angular.module('invoice')
    .service('InvoiceBgtImportService', function (modals) {
        this.open = () => modals.open('app/invoice/bgt/import-modal.html', 'InvoiceBgtImportController', {}, {size: 'md'}, "$ctrl");
    })
    .controller('InvoiceBgtImportController', function ($cookies, $http, $rootScope, $uibModalInstance, toastr, FileUploader, InvoiceConst) {
        this.form = {
            charset: 'CP1250',
            skipInvalidRows: false
        };
        this.result = null;
        this.isChecking = false;
        this.isImporting = false;

        this.$onInit = () => {
            this.uploader = new FileUploader({
                queueLimit: 1,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            });
            this.uploader.onAfterAddingFile = () => this.result = null;
            this.uploader.onWhenAddingFileFailed = () => toastr.error("Możesz wybrać tylko jeden plik");
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.clearFile = () => {
            this.uploader.clearQueue();
            this.result = null;
            angular.element("#invoice-bgt-import-file").val(null);
        };

        this.selectedFileName = () => this.getFileItem()?.file?.name;

        this.check = () => this.upload(true);

        this.import = () => {
            if (!this.result || this.result.success !== true) {
                toastr.warning("Najpierw wykonaj poprawne sprawdzenie pliku");
                return;
            }
            return this.upload(false);
        };

        this.upload = dryRun => {
            let fileItem = this.getFileItem();
            if (!fileItem) {
                toastr.warning("Wybierz plik CSV");
                return;
            }

            this.isChecking = dryRun;
            this.isImporting = !dryRun;

            let data = new FormData();
            data.append('file', fileItem._file);
            data.append('charset', this.form.charset);
            data.append('dryRun', dryRun);
            data.append('skipInvalidRows', this.form.skipInvalidRows);

            return $http.post('/crm/api/invoice-bgt-import', data, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined,
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            }).then(response => {
                this.result = response.data;
                if (this.result.success) {
                    toastr.success(dryRun ? "Sprawdzono plik" : "Zaimportowano BGT");
                    if (!dryRun) {
                        $rootScope.$broadcast(InvoiceConst.eventUpdate);
                        $uibModalInstance.close(this.result);
                    }
                } else {
                    toastr.error("Import wymaga poprawek");
                }
                return this.result;
            }).finally(() => {
                this.isChecking = false;
                this.isImporting = false;
            });
        };

        this.getFileItem = () => this.uploader && this.uploader.queue.length > 0 ? this.uploader.queue[0] : null;
    });
